module.exports = __webpack_public_path__ + "img/cwp.db6faedd.jpg";